import { LoadableLazy } from '@confluence/loadable';

export const LazyAutomationExecutionLimit = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-AutomationExecutionLimitMessage" */ '../src/AutomationExecutionLimitMessage.tsx'
			)
		).AutomationExecutionLimitMessageComponent,
});
